export default {
  productCollection: [],
  productInventory: {},
};
